/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_AllInputs */

const vi_shop_all = /** @type {(inputs: Shop_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả`)
};

/**

* @param {Shop_AllInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_all = /** @type {((inputs?: Shop_AllInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_AllInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_all(inputs)
});